module.exports = __webpack_public_path__ + "img/qrcode1.3d59eca6.jpeg";